import React from "react";

import Assets from "../../pages/cartoondraw/Assets";
import Popular from "../../pages/cartoondraw/Assets/Popular";

const cartoondrawRoutes = [
  { path: '/cartoondraw', element: <Assets /> },
  { path: '/cartoondraw/popular', element: <Popular /> }
]

export default cartoondrawRoutes;
